import { useTheme } from 'styled-components';
import { Button } from '../../../../components/ui/Button/Button';
import ImageWithFallback from '../../../../components/common/ImageWithFallback/ImageWithFallback';
import { ThemeType } from '../../../../theme/themeType';

type EntityPickerProps = {
  entity: string;
  thumbnail: string;
  count: number;
  isSelected: boolean;
  avatar?: string;
  title?: string;
  subtitle?: string;
  toggleModal: (closed: boolean) => void;
  onClick: (args: any) => void;
};

function EntityPicker({
  entity, thumbnail, toggleModal, onClick, count,
  title, subtitle, isSelected, avatar,
}: EntityPickerProps): JSX.Element {
  const theme = useTheme() as ThemeType;
  return (
    <div className={`entity-picker ${isSelected ? 'selected' : ''}`}>
      <ImageWithFallback src={avatar || thumbnail} alt={entity} />
      {isSelected ? (
        <div className="entity-info">
          <span className="title">{`${title}`}</span>
          <span className="subtitle">{`${subtitle}`}</span>
        </div>
      ) : (
        <span className="text">{`${count} available ${entity}s`}</span>
      )}
      <Button
        type="button"
        height="44px"
        padding="10px 12px"
        background={theme.colors.background_dashboard}
        onClick={(): void => {
          onClick(entity);
          toggleModal(true);
        }}
      >
        {`${isSelected ? 'Change' : 'Search'} ${entity}`}
      </Button>
    </div>
  );
}

export default EntityPicker;
